<template>
  <div class="desktron_banner">
    <a href="https://pc.todesk.com/download" class="db_item2 db_item0">
      <div class="db1-info db0-info">
        <p class="title">
          <span>云图形工作站</span>
          <span class="new-tag"><span class="t0">RTX </span><span class="t1">4070</span></span>
        </p>
        <div class="list-text">
          <span class="web_text">专业图形显卡，支持主流设计软件</span>
        </div>
      </div>
    </a>
    <a href="https://pc.todesk.com/download" class="db_item2 db_item1" id="todesk_home_ads_1">
      <div class="db1-info">
        <p class="title">
          <span>云电脑</span>
          <span class="corner-mark">新注册1小时免费</span>
        </p>
        <div class="list-text">
          <span class="web_text">随时随地使用云电脑</span><span class="web_text1">仅限4070配置</span>
        </div>
      </div> 
    </a>
    <a :href="item.link" class="db_item" v-for="(item,index) in list" :key="index">
      <img class="db_item_icon" :src="item.icon" alt="">
      <div class="info">
        <p class="title">{{ item.title }}</p>
        <p class="desc">{{ item.desc }}</p>
      </div>
    </a>
  </div>
</template>
<script>
export default {
  data(){
    return {
      list: [
        {
          title: 'AIGC藏宝地',
          desc: '高算力加持最新AI绘画大模型',
          icon: require('@/assets/desktron/aigc.svg'),
          link: 'https://pc.todesk.com/download',
        },
        {
          title: '高性能远程安全办公',
          desc: '稳定、精准、真高清远程设计',
          icon: require('@/assets/desktron/highperf.svg'),
          link:'https://www.todesk.com/mobile/#/solutions/design',
        },
      ]
    }
  },
  methods: {
    toPage(link){
      location.href = link;
    }
  },
}
</script>
<style lang="less" scoped>
.desktron_banner {
  margin-top: -55px;
  justify-content: center;
  position: relative;
  z-index: 2;
  padding-bottom: 20px;
  .db_item {
    display: flex;
    align-items: center;
    width: 335px;
    box-sizing: border-box;
    padding: 12px;
    height: 72px;
    margin: auto;
    margin-top: 14px;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: linear-gradient(180deg, #FFF 29.17%, #F3F9FF 100%);
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.10), 2px 3px 3px 0px rgba(255, 255, 255, 0.40) inset;
    .db_item_icon {
      width: 48px;
      height: 48px;
      margin-right: 8px;
    }
    .info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        color: #000;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 500;
      }
      .desc {
        color: #616369;
        font-family: PingFang SC;
        font-size: 12px;
        font-weight: 400;
      }
    }
    &:active{
      border: 1px solid #0070F9;
      background: linear-gradient(180deg, #F3F9FF 0%, #FFF 100%),rgba(17, 136, 255, 0.05);
    }
  }

  .db_item2 {
    background: left top / 100% 100% url('https://todeskcdnspeed.todesk.com/2024092911391562339d51a19c7c.png') no-repeat,
    #786560;
    box-shadow: 0px 8.33px 16.67px 0px #00000014,0px 5px 8.33px 0px #FFFFFF80;
    width: 335px;
    height: 80px;
    margin: auto;
    box-sizing: border-box;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    overflow: hidden;
    position: relative;
    &.db_item0 {
      background: left top / 100% 100% url('https://todeskcdnspeed.todesk.com/20241101165618625d61bbf09050.png') no-repeat;
      .title {
        display: flex;
        align-items: end;
        .new-tag {
          height: 16px;
          margin-left: 6px;
        }
      }
    }
    &.db_item1 {
      margin-top: 14px;
    }
    .db1-info{
      margin-right: 0px;
      padding-left: 20px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      .title {
        color: #fff;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 600;
        display: flex;
        align-items: center;
      }
      .corner-mark {
        background: linear-gradient(90deg, #FFC450 0%, #FFDC26 100%);
        border-radius: 8px 8px 8px 0px;
        font-size: 10px;
        font-weight: 500;
        line-height: 16px;
        padding: 1px 5px 1px 6px;
        height: 15px;
        color: #000405E5;
        width: 94px;
        width: max-content;
        margin-left: 6px;
      }
      .list-text{
        margin-top: 6px;
        .web_text{
          font-size: 12px;
          color: #FFFFFF;
          margin-right: 4px;
        }
        .web_text1{
          border: 1px solid #FFFFFF66;
          background: rgba(0, 0, 0, 0.8);
          padding: 2px 5px 2px 5px;
          color: #FFFFFFD9;
          font-size: 10px;
          margin: 0px 4px 0px 0px;
          border-radius: 4px;
        }
      }

      &.db0-info {
        .new-tag{
          border-radius: 4px;
          border: 1px solid #91D519;
          background: #111;
          font-size: 10px;
          font-weight: 500;
          line-height: 15px;
          padding: 2px 6px;
          height: 14px;
          .t0 {
            color: #FFF;
          }
          .t1 {
            color: #91D519;
          }
        }
      }
    }
    .db1_icon{
      width: auto;
      height: 96px;
      margin-right: 8px;
    }
    &:hover{
    }
    &:active{
    }
  }
}
</style>
